
import { Howl } from 'howler'
import buttonSound from '../../audios/click-action.mp3'
import cashOutSound from '../../audios/cash-out.mp3'
import frogJumpSound from '../../audios/frog-jump.mp3'
import lostSound from '../../audios/lost-funny-audio.mp3'
import bgSound from '../../audios/bb-bg.mp3'

export const clickSfx = new Howl({ src: [buttonSound] })

export const cashOutSfx = new Howl({ src: [cashOutSound] })

export const JumpSfx = new Howl({ src: [frogJumpSound] })

export const lostSfx = new Howl({ src: [lostSound] })

export const waterFlowSfx = new Howl({ src: [bgSound], loop: true })
